export const page_title = [{ page: 'home-page', title: 'Homepage | Georgia Communicare'},
{page: 'privacy-policy', title: 'Privacy Policy | Georgia Communicare'},
{page: 'terms-and-conditions', title: 'Terms and Conditions | Georgia Communicare'},
{page: 'terms-and-conditions-and-privacy-policy', title: 'Terms and Conditions and Privacy Policy | Georgia Communicare'},
{page: 'report-designer', title: 'Report Designer | Georgia Communicare'},
{page: 'analytics', title: 'Analytics | Georgia Communicare'},
{page: 'workflow', title: 'WorkFlow | Georgia Communicare'},
{page: 'profile', title: 'Profile | Georgia Communicare'},
{page: 'timesheet', title: 'Timesheet | Georgia Communicare'},
{page: 'timesheet-approval', title: 'Timesheet Approval | Georgia Communicare'},
{page: 'chat-newuser', title: 'Chat New User | Georgia Communicare'},
{page: 'contact-support', title: 'Contact Support | Georgia Communicare'},
{page: 'contact-support-list', title: 'Contact Support List | Georgia Communicare'},
{page: 'thank-you', title: 'Thank You | Georgia Communicare'},
{page: 'config-dashboard', title: 'Config Dashboard | Georgia Communicare'},
{page: 'dashboard', title: 'Dashboard | Georgia Communicare'},
{page: 'policy-groups', title: 'Policy Group | Georgia Communicare'},
{page: 'roles', title: 'Roles | Georgia Communicare'},
{page: 'page-access-list', title: 'Page Access List | Georgia Communicare'},
{page: 'page-access', title: 'Page Access | Georgia Communicare'},
{page: 'form', title: 'Page Access Form | Georgia Communicare'},
{page: 'users', title: 'Users | Georgia Communicare'},
{page: 'deactive-user', title: 'Deactivated Users | Georgia Communicare'},
{page: 'masters', title: 'Masters | Georgia Communicare'},
{page: 'page-permissions', title: 'Page Permissions | Georgia Communicare'},
{page: 'organization', title: 'Organization | Georgia Communicare'},
{page: 'basic-info', title: 'Basic Information | Georgia Communicare'},
{page: 'routing-config', title: 'Routing Config | Georgia Communicare'},
{page: 'tab-config', title: 'Tab Config | Georgia Communicare'},
{page: 'grid-field', title: 'Grid Field | Georgia Communicare'},
{page: 'search-params', title: 'Search Params | Georgia Communicare'},
{page: 'page-design', title: 'Page Design | Georgia Communicare'},
{page: 'videos', title: 'Videos | Georgia Communicare'},
{page: 'documents', title: 'Documents | Georgia Communicare'},
{page: 'faq', title: 'FAQ | Georgia Communicare'},
{page: 'contact-us', title: 'Contact Us | Georgia Communicare'},
{page: 'history', title: 'Chat History | Georgia Communicare'},
{page: 'appointment-list', title: 'Appoinments List | Georgia Communicare'},
{page: 'cancel-list', title: 'Canceled Appointments List | Georgia Communicare'},
{page: 'search', title: 'Case Assignment Search | Georgia Communicare'},
{page: 'assigned-cases', title: 'Assigned Cases | Georgia Communicare'},
{page: 'demographics', title: 'Demographics | Georgia Communicare'},
{page: 'child-placement', title: 'Child Placement | Georgia Communicare'},
{page: 'children-first-referral', title: "Children's First Referral | Georgia Communicare"},
{page: 'education-detail', title: 'Education Detail | Georgia Communicare'},
{page: 'health-log', title: 'Health Log | Georgia Communicare'},
{page: 'medication', title: 'Medication | Georgia Communicare'},
{page: 'characteristics-diagnosis', title: 'Characteristics/Diagnosis | Georgia Communicare'},
{page: 'tribal-Information', title: 'Tribal Information | Georgia Communicare'},
{page: 'caregiver-parent', title: 'Caregiver/Parent Relationship Information | Georgia Communicare'},
{page: 'document', title: 'Document | Georgia Communicare'},
{page: 'chat', title: 'Chat | Georgia Communicare'},
{page: 'appointments', title: 'Appointments | Georgia Communicare'},
{page: 'child-overview', title: 'Child Overview | Georgia Communicare'},
{page: 'history-list', title: 'Document History List | Georgia Communicare'},
{page: 'submit-list', title: 'Document List | Georgia Communicare'},
{page: 'login', title: 'Login | Georgia Communicare'},
{page: 'federatedlogin', title: 'Federated Login | Georgia Communicare'},
{page: 'validate', title: 'Validate | Georgia Communicare'},
{page: 'logout', title: ' Federated Logout | Georgia Communicare'},
{page: 'change-password', title: 'Change Password | Georgia Communicare'},
{page: 'forgot-password', title: 'Forgot Password | Georgia Communicare'},
{page: 'migrate', title: 'Migrate User | Georgia Communicare'},
{page: 'list', title: 'Migrate User List | Georgia Communicare'},
{page: 'details', title: 'Migrate User Details | Georgia Communicare'},
{page: 'person-view', title: 'Staff Contact Information | Georgia Communicare'},
{page: 'case-search', title: 'Case Search | Georgia Communicare'},
{page: 'evaluations', title: 'Child Evaluations | Georgia Communicare'},
{page: 'assessments', title: 'Child Assessments | Georgia Communicare'},
{page: 'reports', title: 'Child Reports | Georgia Communicare'},
{page: 'datainfo', title: 'Child Data | Georgia Communicare'},
{page: 'forms', title: 'Child Forms | Georgia Communicare'},
{page: 'document-packetization', title: 'Document Packetization | Georgia Communicare'},
{page: 'email-template', title: 'Email Template | Georgia Communicare'},
{page: 'help-desk', title: 'Help Desk | Georgia Communicare'},
{page: 'ocr-validation', title: 'OCR | Georgia Communicare'},
{page: 'main-notification', title: 'User Notification | Georgia Communicare'},
{page: 'event-scheduler', title: 'Appointment Scheduler | Georgia Communicare'},
{page: 'video-conferencing', title: 'Video Conferencing | Georgia Communicare'},
{page: 'groups-roles', title: 'Groups Roles | Georgia Communicare'},
{page: 'add', title: 'Page Builder Add | Georgia Communicare'},
{page: 'versions', title: 'Page Version | Georgia Communicare'},
{page: 'modify', title: 'Dynamic Page Modify | Georgia Communicare'},
{page: 'tab', title: 'Dynamic Tab | Georgia Communicare'},
{page: 'view', title: 'Dynamic Page View | Georgia Communicare'},
{page: 'others-list', title: 'Others List | Georgia Communicare'},
];
